// this fuction return the first and last day of the current month
export function getFirstAndLastDateOfCurrentMonth(): { first: Date, last: Date } {
    const currentDate = new Date();
    const first = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const last = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    return { first, last };
}

export function toLocalISOString(date: Date): string {
    const pad = (n: number) => n.toString().padStart(2, '0');
  
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  }

export function formatDate(dateStr: string,separator: string ="/"): string {
    const date = new Date(dateStr);

    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();
    const day = String(date.getDate()).padStart(2, '0');

    return `${month}${separator}${day}${separator}${year}`;
}


export function sonFechasIguales(fecha1: Date, fecha2: Date): boolean {
    if (!fecha1 && !fecha2) return true;
    if (!fecha1 || !fecha2) return false;
    return (
      fecha1.getFullYear() === fecha2.getFullYear() &&
      fecha1.getMonth() === fecha2.getMonth() &&
      fecha1.getDate() === fecha2.getDate()
    );
  }
